import { UploadData, useUploadStore } from '../uploadStore';
import { UploadType } from '../../consts/uploadType';
import { getUploadTotalSize } from '../../components/main_container/missions/helpers/uploadProgress';

export const cacheUploadSize = (upload: UploadData, save = false) => {
  if (!upload.upload) {
    throw new Error("The upload hasn't been registered");
  }

  const args = [
    upload.meta.type === UploadType.Pano,
    upload.upload.customer,
    upload.upload.site,
    upload.upload.flightScheduleId,
  ] as const;

  const registrationRequests = useUploadStore.getState().getRegistrationRequests(...args);
  upload.meta.uploadSize = getUploadTotalSize(upload, registrationRequests);

  if (save) {
    useUploadStore.getState().setUpload(...args, upload);
  }
};
